import { render, staticRenderFns } from "./exam-edit.vue?vue&type=template&id=0972cfb6&scoped=true"
import script from "./exam-edit.vue?vue&type=script&lang=ts"
export * from "./exam-edit.vue?vue&type=script&lang=ts"
import style0 from "./exam-edit.vue?vue&type=style&index=0&id=0972cfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972cfb6",
  null
  
)

export default component.exports